import Env from "./Env";

const getConfigs = () => {
  const configs = {
    useFakeModels: Env.USE_FAKE_MODEL,
    apiToken: Env.APP_API_TOKEN,
    propertyTitle: Env.APP_PROPERTY_TITLE,
    baseUrl: Env.BASE_URL,
    loginBaseUrl: Env.APP_LOGIN,
    logoutClearCookieEndpoint:
      Env.APP_API_GATEWAY + "/oauth2-callback?action=logout",
    cloudfrontImgUrl: Env.APP_CLOUDFRONT_URLIMG,
    getCarouselPublicEndpoint: Env.APP_API_GATEWAY + "/carouselPublic",
    getCarouselEndpoint: Env.APP_API_GATEWAY + "/carousel",
    getTextEndpoint: Env.APP_API_GATEWAY + "/text",
    getFormEndpoint: Env.APP_API_GATEWAY + "/request",
    getSearchEndpoint: Env.APP_API_GATEWAY + "/search",
    getFollowingEndpoint: Env.APP_API_GATEWAY + "/following",
    getDetailsEndpoint: Env.APP_API_GATEWAY + "/details",
    testLoginEndpoint: Env.APP_API_GATEWAY + "/test-login",
    getShareEndpoint: Env.APP_API_GATEWAY + "/share",
    getLogDownloadEndpoint: Env.APP_API_GATEWAY + "/logDownload",
    getConfigurationsEndpoint: Env.APP_API_GATEWAY + "/configuration",
    getChannelsGridEndpoint: Env.APP_API_GATEWAY + "/channelsGrid",
    showImagesQuery: "?p=1c563c67-963a-4279-964e-435e2707d3d8",
    channelsLogosUrl: Env.CLOUDFRONT_CHANNELS_LOGOS_URL,
    searchPageSize: 8,
    contentTypeMapping: {
      Movie: Env.MOVIE,
      StandaloneEpisode: Env.PROGRAMMES,
      Season: Env.SEASON,
    },
    contentType: {
      Movie: "Movie",
      Episode: "Standalone/Episode",
      Season: "Season",
    },
    placeholderImageUrl: Env.PLACEHOLDER_IMG_URL,
    imagesBuket: Env.IMAGES_BUCKET,
    downloadBaseUrl: Env.APP_DOWNLOAD_BASE_URL,
    portalCognitoGroups: [
      "PortalExternalPress",
      "PortalExternalMarketing",
      "PortalInternalMarketing",
      "PortalInternalPress",
      "SportsInternalPress",
      "SportsExternalPress",
      "NewsInternalPress",
      "NewsExternalPress",
      "MediaLogistic",
    ],
    defaultFileExtension: "jpg",
    defaultIccProfile: "srgb",
  };
  return configs;
};

export default getConfigs();
